import { Injectable } from '@angular/core';
import { Camera, CameraOptions, DestinationType } from '@ionic-native/camera';

import { ServidorProvider } from '../servidor/servidor'

@Injectable()
export class FotoProvider {

  constructor(private camera: Camera) {}

  private criarParametrosCameraGenricos(width: number, height: number, qualidade: number, destinationType: DestinationType): CameraOptions {
  
    const parametrosDaCamera: CameraOptions = {
      quality: qualidade,
      destinationType: destinationType,
      targetWidth: width,
      targetHeight: height,
      encodingType: this.camera.EncodingType.JPEG,
      correctOrientation: true
    }

    return parametrosDaCamera
  }

  public async tirarFoto(width = undefined, height = undefined, quality = 100, destinationType = DestinationType.DATA_URL): Promise<string> {
    const parametros = this.criarParametrosCameraGenricos(width, height, quality, destinationType);
    parametros.encodingType = this.camera.EncodingType.JPEG;
    return this.getFoto(parametros);
  }

  public async abrirImagemDaGaleria(width = undefined, height = undefined, quality = 100, destinationType = DestinationType.DATA_URL): Promise<string> {
    const parametros = this.criarParametrosCameraGenricos(width, height, quality, destinationType);
    parametros.sourceType = this.camera.PictureSourceType.PHOTOLIBRARY;
    return this.getFoto(parametros);
  }

  private async getFoto(parametrosDaCamera: CameraOptions): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      this.camera.getPicture(parametrosDaCamera).then((data) => {
        resolve(data);
      }, (error) => {
        reject(error);
      });
    })
  }

  public getUrlImagemServidor(hash: string): string {
    return `${ServidorProvider.URL_SERVIDOR_BRCOMUNIQUE}/api/v1/file/download/${hash}/I/50/${hash}.jpg`;
  }
}



// WEBPACK FOOTER //
// ./src/providers/foto/foto.ts